import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';

export const getTnCStatus = () =>
  httpClient
    .get('/tnc/status')
    .then(response => response)
    .catch(apiErrorHandler);

export const getTnCDocument = () =>
  httpClient
    .get('/tnc/document')
    .then(response => response)
    .catch(apiErrorHandler);

export const acceptTnC = () =>
  httpClient
    .post('/tnc/accept', {})
    .then(response => response)
    .catch(apiErrorHandler);
